const physicsQuestions = [

{
  question: "Which of the following expressions is dimensionally correct for velocity?",
  options: ["LT⁻¹", "L²T⁻²", "LT", "L⁻¹T"],
  answer: "LT⁻¹"
},
{
  question: "Which quantity has the same dimensions as work?",
  options: ["Energy", "Force", "Pressure", "Momentum"],
  answer: "Energy"
},
{
  question: "The dimensions of pressure are:",
  options: ["ML⁻¹T⁻²", "MLT⁻²", "M⁻¹LT⁻²", "ML²T⁻¹"],
  answer: "ML⁻¹T⁻²"
},
{
  question: "Which of the following is a derived quantity?",
  options: ["Force", "Mass", "Time", "Length"],
  answer: "Force"
},
{
  question: "Which instrument is most suitable for measuring the diameter of a thin wire with high precision?",
  options: ["Micrometer screw gauge", "Metre rule", "Vernier calipers", "Measuring tape"],
  answer: "Micrometer screw gauge"
},
{
  question: "Which of the following quantities is a vector?",
  options: ["Acceleration", "Speed", "Temperature", "Energy"],
  answer: "Acceleration"
},
{
  question: "Which of the following is NOT a scalar quantity?",
  options: ["Force", "Mass", "Time", "Distance"],
  answer: "Force"
},
{
  question: "The resultant of two perpendicular vectors of magnitudes 6N and 8N is:",
  options: ["10N", "14N", "2N", "48N"],
  answer: "10N"
},
{
  question: "Which of the following has dimension ML²T⁻²?",
  options: ["Energy", "Force", "Power", "Pressure"],
  answer: "Energy"
},
{
  question: "Which quantity is measured in kg m⁻³?",
  options: ["Density", "Pressure", "Force", "Energy"],
  answer: "Density"
},
{
  question: "A physical quantity that has magnitude but no direction is called:",
  options: ["Scalar", "Vector", "Tensor", "Unit"],
  answer: "Scalar"
},
{
  question: "Which of the following is the SI unit of electric current?",
  options: ["Ampere", "Volt", "Ohm", "Coulomb"],
  answer: "Ampere"
},
{
  question: "Which of the following expressions represents force in terms of base units?",
  options: ["kg m s⁻²", "kg m² s⁻¹", "kg⁻¹ m s²", "kg m s"],
  answer: "kg m s⁻²"
},
{
  question: "Which of the following quantities has the dimension of momentum?",
  options: ["MLT⁻¹", "ML²T⁻²", "ML⁻¹T⁻²", "M⁻¹LT"],
  answer: "MLT⁻¹"
},
{
  question: "Which of the following is a correct example of vector addition?",
  options: ["Displacement + displacement", "Speed + time", "Mass + force", "Energy + power"],
  answer: "Displacement + displacement"
},
{
  question: "The SI unit of power is:",
  options: ["Watt", "Joule", "Newton", "Pascal"],
  answer: "Watt"
},
{
  question: "Which of the following best describes a fundamental quantity?",
  options: ["Independent physical quantity", "Derived from other quantities", "Combination of units", "Dimensionless value"],
  answer: "Independent physical quantity"
},
{
  question: "The error in a measurement using a metre rule is approximately:",
  options: ["±0.1 cm", "±1 cm", "±0.01 cm", "±0.5 cm"],
  answer: "±0.1 cm"
},
{
  question: "Which of the following is NOT a base SI unit?",
  options: ["Newton", "Metre", "Kilogram", "Second"],
  answer: "Newton"
},
{
  question: "If a quantity has dimensions M⁰L⁰T⁰, it is:",
  options: ["Dimensionless", "Scalar", "Vector", "Derived"],
  answer: "Dimensionless"
},

{
  question: "A force of 20 N acts at 30° to the horizontal. Its horizontal component is:",
  options: ["17.3 N", "10 N", "15 N", "20 N"],
  answer: "17.3 N"
},
{
  question: "A body moves with constant velocity. Which statement is correct?",
  options: ["Acceleration is zero", "Force is increasing", "Speed is changing", "Direction is changing"],
  answer: "Acceleration is zero"
},
{
  question: "The area under a velocity-time graph represents:",
  options: ["Displacement", "Acceleration", "Speed", "Force"],
  answer: "Displacement"
},
{
  question: "The gradient of a displacement-time graph gives:",
  options: ["Velocity", "Acceleration", "Distance", "Speed"],
  answer: "Velocity"
},
{
  question: "A car accelerates uniformly from rest to 20 m/s in 5 s. Its acceleration is:",
  options: ["4 m/s²", "5 m/s²", "2 m/s²", "10 m/s²"],
  answer: "4 m/s²"
},
{
  question: "Two vectors of equal magnitude act in opposite directions. Their resultant is:",
  options: ["Zero", "Twice the magnitude", "Half the magnitude", "Same magnitude"],
  answer: "Zero"
},
{
  question: "A body moving in a circle at constant speed has:",
  options: ["Changing velocity", "Zero acceleration", "Constant displacement", "No force acting"],
  answer: "Changing velocity"
},
{
  question: "The centripetal force acts:",
  options: ["Towards the centre", "Away from the centre", "Tangentially", "Vertically upward"],
  answer: "Towards the centre"
},
{
  question: "If velocity doubles, kinetic energy becomes:",
  options: ["Four times", "Twice", "Half", "Unchanged"],
  answer: "Four times"
},
{
  question: "A displacement-time graph is a straight line. This indicates:",
  options: ["Constant velocity", "Increasing acceleration", "Decreasing speed", "Zero velocity"],
  answer: "Constant velocity"
},
{
  question: "A car travels 100 m in 10 s, then 200 m in 20 s. Its average speed is:",
  options: ["10 m/s", "15 m/s", "20 m/s", "5 m/s"],
  answer: "10 m/s"
},
{
  question: "A projectile reaches maximum height when:",
  options: ["Vertical velocity is zero", "Horizontal velocity is zero", "Acceleration is zero", "Speed is maximum"],
  answer: "Vertical velocity is zero"
},
{
  question: "The time taken for a freely falling object depends on:",
  options: ["Height only", "Mass only", "Velocity only", "Air resistance only"],
  answer: "Height only"
},
{
  question: "Which of the following quantities is always constant in uniform circular motion?",
  options: ["Speed", "Velocity", "Acceleration", "Displacement"],
  answer: "Speed"
},
{
  question: "A stone is thrown vertically upward. At the highest point, its:",
  options: ["Velocity is zero but acceleration is not zero", "Velocity and acceleration are zero", "Acceleration is zero", "Velocity is maximum"],
  answer: "Velocity is zero but acceleration is not zero"
},
{
  question: "Relative velocity is the velocity of one object:",
  options: ["With respect to another", "With respect to ground only", "In circular motion", "Due to gravity only"],
  answer: "With respect to another"
},
{
  question: "If two cars move in opposite directions, their relative speed is:",
  options: ["Sum of their speeds", "Difference of speeds", "Zero", "Average speed"],
  answer: "Sum of their speeds"
},
{
  question: "A body moving with uniform acceleration has:",
  options: ["Constant rate of change of velocity", "Constant velocity", "Zero acceleration", "Variable force only"],
  answer: "Constant rate of change of velocity"
},
{
  question: "The SI unit of acceleration is:",
  options: ["m/s²", "m/s", "m²/s", "s/m"],
  answer: "m/s²"
},
{
  question: "Which graph represents uniform acceleration?",
  options: ["Straight line velocity-time graph", "Horizontal displacement-time graph", "Curved velocity-time graph", "Vertical displacement-time graph"],
  answer: "Straight line velocity-time graph"
},

{
  question: "A body of mass 5 kg experiences a force of 20 N. Its acceleration is:",
  options: ["4 m/s²", "5 m/s²", "2 m/s²", "10 m/s²"],
  answer: "4 m/s²"
},
{
  question: "Newton’s first law is also known as the law of:",
  options: ["Inertia", "Acceleration", "Momentum", "Energy"],
  answer: "Inertia"
},
{
  question: "The inertia of a body depends on its:",
  options: ["Mass", "Velocity", "Volume", "Shape"],
  answer: "Mass"
},
{
  question: "A force that always opposes motion is:",
  options: ["Friction", "Tension", "Weight", "Normal reaction"],
  answer: "Friction"
},
{
  question: "Which type of friction acts on a body moving through air?",
  options: ["Air resistance", "Static friction", "Sliding friction", "Limiting friction"],
  answer: "Air resistance"
},
{
  question: "The unit of force is:",
  options: ["Newton", "Joule", "Watt", "Pascal"],
  answer: "Newton"
},
{
  question: "Which of the following is an example of Newton’s third law?",
  options: ["Action and reaction are equal and opposite", "Force equals mass times acceleration", "Objects remain at rest", "Energy is conserved"],
  answer: "Action and reaction are equal and opposite"
},
{
  question: "The momentum of a body is given by:",
  options: ["Mass × velocity", "Force × time", "Mass × acceleration", "Velocity ÷ mass"],
  answer: "Mass × velocity"
},
{
  question: "The SI unit of momentum is:",
  options: ["kg m/s", "kg m/s²", "N m", "J s"],
  answer: "kg m/s"
},
{
  question: "A body of mass 2 kg moves with velocity 5 m/s. Its momentum is:",
  options: ["10 kg m/s", "7 kg m/s", "5 kg m/s", "2.5 kg m/s"],
  answer: "10 kg m/s"
},
{
  question: "Impulse is equal to:",
  options: ["Change in momentum", "Force × distance", "Mass × acceleration", "Velocity × time"],
  answer: "Change in momentum"
},
{
  question: "Which of the following conserves momentum?",
  options: ["Isolated system", "Open system", "Frictional system", "Thermal system"],
  answer: "Isolated system"
},
{
  question: "The weight of a body is given by:",
  options: ["mg", "mv", "ma", "m/g"],
  answer: "mg"
},
{
  question: "Which force acts perpendicular to a surface?",
  options: ["Normal reaction", "Friction", "Tension", "Weight"],
  answer: "Normal reaction"
},
{
  question: "The coefficient of friction is defined as:",
  options: ["Frictional force ÷ normal reaction", "Normal reaction ÷ friction", "Force × distance", "Mass ÷ force"],
  answer: "Frictional force ÷ normal reaction"
},
{
  question: "A car of mass 1000 kg accelerates at 2 m/s². The force acting on it is:",
  options: ["2000 N", "500 N", "1000 N", "4000 N"],
  answer: "2000 N"
},
{
  question: "Centripetal force required for circular motion depends on:",
  options: ["Mass, velocity and radius", "Mass only", "Velocity only", "Radius only"],
  answer: "Mass, velocity and radius"
},
{
  question: "If the speed of a body in circular motion doubles, centripetal force becomes:",
  options: ["Four times", "Twice", "Half", "Unchanged"],
  answer: "Four times"
},
{
  question: "Which of the following best explains why passengers lean outward in a turning car?",
  options: ["Inertia of motion", "Friction", "Gravity", "Normal force"],
  answer: "Inertia of motion"
},
{
  question: "The tension in a string is a force that acts:",
  options: ["Along the string", "Perpendicular to the string", "Opposite to motion", "Vertically upward only"],
  answer: "Along the string"
},

{
  question: "Work is done when a force:",
  options: ["causes displacement in its direction", "acts without movement", "is balanced", "is perpendicular to displacement"],
  answer: "causes displacement in its direction"
},
{
  question: "The SI unit of work is:",
  options: ["Joule", "Watt", "Newton", "Pascal"],
  answer: "Joule"
},
{
  question: "Which of the following represents kinetic energy?",
  options: ["½mv²", "mv", "mgh", "Fv"],
  answer: "½mv²"
},
{
  question: "Potential energy depends on:",
  options: ["Height and mass", "Velocity and mass", "Time and force", "Distance only"],
  answer: "Height and mass"
},
{
  question: "The SI unit of power is:",
  options: ["Watt", "Joule", "Newton", "Volt"],
  answer: "Watt"
},
{
  question: "Power is defined as:",
  options: ["Rate of doing work", "Work done per unit distance", "Force × velocity", "Energy × time"],
  answer: "Rate of doing work"
},
{
  question: "A machine is said to be efficient when:",
  options: ["Useful output is close to input", "Input is zero", "Output is greater than input", "Energy is destroyed"],
  answer: "Useful output is close to input"
},
{
  question: "Efficiency is given by:",
  options: ["Useful output ÷ input × 100%", "Input ÷ output × 100%", "Output − input", "Input × output"],
  answer: "Useful output ÷ input × 100%"
},
{
  question: "Which of the following is an example of mechanical energy?",
  options: ["Kinetic energy", "Chemical energy", "Electrical energy", "Thermal energy"],
  answer: "Kinetic energy"
},
{
  question: "A body of mass 2 kg moves at 3 m/s. Its kinetic energy is:",
  options: ["9 J", "6 J", "12 J", "18 J"],
  answer: "9 J"
},
{
  question: "Which of the following forms of energy is stored in fuels?",
  options: ["Chemical energy", "Kinetic energy", "Thermal energy", "Light energy"],
  answer: "Chemical energy"
},
{
  question: "The principle of conservation of energy states that energy:",
  options: ["cannot be created or destroyed", "can be destroyed", "is always increasing", "is always decreasing"],
  answer: "cannot be created or destroyed"
},
{
  question: "Work done against gravity is stored as:",
  options: ["Potential energy", "Kinetic energy", "Thermal energy", "Electrical energy"],
  answer: "Potential energy"
},
{
  question: "Which of the following reduces efficiency of a machine?",
  options: ["Friction", "Lubrication", "Smooth surfaces", "Reduced load"],
  answer: "Friction"
},
{
  question: "A force of 10 N moves an object through 5 m. Work done is:",
  options: ["50 J", "2 J", "15 J", "10 J"],
  answer: "50 J"
},
{
  question: "Which of the following is a simple machine?",
  options: ["Lever", "Engine", "Generator", "Transformer"],
  answer: "Lever"
},
{
  question: "In a first-class lever, the fulcrum is:",
  options: ["Between effort and load", "At the end", "Near the load", "Near the effort"],
  answer: "Between effort and load"
},
{
  question: "Mechanical advantage is defined as:",
  options: ["Load ÷ effort", "Effort ÷ load", "Load × effort", "Effort − load"],
  answer: "Load ÷ effort"
},
{
  question: "Velocity ratio is defined as:",
  options: ["Distance moved by effort ÷ distance moved by load", "Load ÷ effort", "Effort × distance", "Load × distance"],
  answer: "Distance moved by effort ÷ distance moved by load"
},
{
  question: "A machine has efficiency 80%. This means:",
  options: ["80% of input energy is useful output", "Energy is lost completely", "Output is greater than input", "Input is zero"],
  answer: "80% of input energy is useful output"
},

{
  question: "Temperature is a measure of the:",
  options: ["average kinetic energy of particles", "total heat content", "mass of particles", "density of substance"],
  answer: "average kinetic energy of particles"
},
{
  question: "Heat is best defined as:",
  options: ["energy transferred due to temperature difference", "internal energy of a body", "temperature of a substance", "energy stored in bonds"],
  answer: "energy transferred due to temperature difference"
},
{
  question: "Which scale has absolute zero at 0 K?",
  options: ["Kelvin scale", "Celsius scale", "Fahrenheit scale", "Thermodynamic scale"],
  answer: "Kelvin scale"
},
{
  question: "0°C is equivalent to:",
  options: ["273 K", "273°C", "0 K", "100 K"],
  answer: "273 K"
},
{
  question: "Which property of a substance is used in liquid-in-glass thermometers?",
  options: ["Thermal expansion", "Density", "Pressure", "Volume only"],
  answer: "Thermal expansion"
},
{
  question: "Which of the following expands most on heating?",
  options: ["Gases", "Liquids", "Solids", "Metals"],
  answer: "Gases"
},
{
  question: "The SI unit of heat energy is:",
  options: ["Joule", "Watt", "Calorie", "Kelvin"],
  answer: "Joule"
},
{
  question: "Specific heat capacity is the amount of heat required to:",
  options: ["raise temperature of 1 kg by 1 K", "raise temperature of any mass by 1°C", "change state of substance", "increase pressure"],
  answer: "raise temperature of 1 kg by 1 K"
},
{
  question: "Which material has the highest specific heat capacity?",
  options: ["Water", "Iron", "Copper", "Aluminium"],
  answer: "Water"
},
{
  question: "Which process occurs at constant temperature?",
  options: ["Change of state", "Heating of gas", "Expansion of metal", "Compression of air"],
  answer: "Change of state"
},
{
  question: "Latent heat is the heat required to:",
  options: ["change state without temperature change", "increase temperature", "reduce temperature", "increase pressure"],
  answer: "change state without temperature change"
},
{
  question: "Which of the following involves latent heat?",
  options: ["Melting of ice", "Heating water", "Cooling air", "Expansion of gas"],
  answer: "Melting of ice"
},
{
  question: "Boyle’s law states that for a fixed mass of gas at constant temperature:",
  options: ["Pressure is inversely proportional to volume", "Pressure is directly proportional to volume", "Temperature is constant", "Volume is constant"],
  answer: "Pressure is inversely proportional to volume"
},
{
  question: "Charles’ law states that:",
  options: ["Volume is directly proportional to temperature", "Pressure is constant", "Volume is constant", "Temperature is inversely proportional to pressure"],
  answer: "Volume is directly proportional to temperature"
},
{
  question: "Which of the following increases pressure of a gas?",
  options: ["Decrease in volume", "Decrease in temperature", "Decrease in mass", "Increase in volume"],
  answer: "Decrease in volume"
},
{
  question: "Which process involves transfer of heat by direct contact?",
  options: ["Conduction", "Convection", "Radiation", "Evaporation"],
  answer: "Conduction"
},
{
  question: "Heat transfer in fluids occurs mainly by:",
  options: ["Convection", "Conduction", "Radiation", "Reflection"],
  answer: "Convection"
},
{
  question: "Radiation is heat transfer through:",
  options: ["Electromagnetic waves", "Particles", "Conduction only", "Convection only"],
  answer: "Electromagnetic waves"
},
{
  question: "Which surface is the best absorber of heat?",
  options: ["Black dull surface", "Shiny surface", "White surface", "Smooth metal"],
  answer: "Black dull surface"
},
{
  question: "Evaporation causes cooling because:",
  options: ["high energy particles escape", "temperature increases", "particles slow down", "pressure increases"],
  answer: "high energy particles escape"
},

{
  question: "A wave is defined as:",
  options: ["transfer of energy without transfer of matter", "movement of particles from one place to another", "flow of energy and matter together", "oscillation of particles only"],
  answer: "transfer of energy without transfer of matter"
},
{
  question: "Which of the following is a transverse wave?",
  options: ["Light wave", "Sound wave", "Water flow", "Air current"],
  answer: "Light wave"
},
{
  question: "Which of the following is a longitudinal wave?",
  options: ["Sound wave", "Light wave", "Water surface wave", "Electromagnetic wave"],
  answer: "Sound wave"
},
{
  question: "The speed of a wave is given by:",
  options: ["frequency × wavelength", "wavelength ÷ frequency", "frequency ÷ wavelength", "wavelength × time"],
  answer: "frequency × wavelength"
},
{
  question: "The unit of frequency is:",
  options: ["Hertz", "Metre", "Second", "Joule"],
  answer: "Hertz"
},
{
  question: "The time taken for one complete wave cycle is called:",
  options: ["Period", "Frequency", "Amplitude", "Wavelength"],
  answer: "Period"
},
{
  question: "Which of the following determines the pitch of a sound?",
  options: ["Frequency", "Amplitude", "Speed", "Wavelength"],
  answer: "Frequency"
},
{
  question: "Which of the following determines the loudness of a sound?",
  options: ["Amplitude", "Frequency", "Speed", "Wavelength"],
  answer: "Amplitude"
},
{
  question: "The speed of sound is greatest in:",
  options: ["Solids", "Liquids", "Gases", "Vacuum"],
  answer: "Solids"
},
{
  question: "Echo is produced due to:",
  options: ["Reflection of sound waves", "Refraction of sound waves", "Diffraction of sound waves", "Absorption of sound"],
  answer: "Reflection of sound waves"
},
{
  question: "The angle of incidence is equal to the angle of reflection when measured from the:",
  options: ["Normal", "Surface", "Mirror edge", "Light source"],
  answer: "Normal"
},
{
  question: "Which of the following is a characteristic of plane mirrors?",
  options: ["Image is virtual and upright", "Image is real and inverted", "Image is magnified", "Image is distorted"],
  answer: "Image is virtual and upright"
},
{
  question: "Refraction occurs due to change in:",
  options: ["Speed of light in different media", "Frequency of light", "Amplitude of light", "Direction of source"],
  answer: "Speed of light in different media"
},
{
  question: "Which of the following remains constant when light refracts?",
  options: ["Frequency", "Speed", "Wavelength", "Direction"],
  answer: "Frequency"
},
{
  question: "The refractive index is defined as:",
  options: ["Speed of light in vacuum ÷ speed in medium", "Speed in medium ÷ speed in vacuum", "Wavelength ÷ frequency", "Frequency ÷ wavelength"],
  answer: "Speed of light in vacuum ÷ speed in medium"
},
{
  question: "When light enters a denser medium, it:",
  options: ["slows down and bends towards the normal", "speeds up and bends away from normal", "does not change speed", "reflects completely"],
  answer: "slows down and bends towards the normal"
},
{
  question: "Total internal reflection occurs when:",
  options: ["angle of incidence exceeds critical angle", "angle is zero", "light enters less dense medium", "light speed increases"],
  answer: "angle of incidence exceeds critical angle"
},
{
  question: "Which device uses total internal reflection?",
  options: ["Optical fibre", "Plane mirror", "Convex lens", "Prism only"],
  answer: "Optical fibre"
},
{
  question: "A convex lens is used to:",
  options: ["converge light rays", "diverge light rays", "reflect light", "absorb light"],
  answer: "converge light rays"
},
{
  question: "Which of the following best explains why sound cannot travel in vacuum?",
  options: ["It requires a material medium", "It has no energy", "It travels too fast", "It reflects only"],
  answer: "It requires a material medium"
},

{
  question: "Electric current is defined as the rate of flow of:",
  options: ["electric charge", "energy", "potential difference", "resistance"],
  answer: "electric charge"
},
{
  question: "The SI unit of electric charge is:",
  options: ["Coulomb", "Ampere", "Volt", "Ohm"],
  answer: "Coulomb"
},
{
  question: "One coulomb is equal to:",
  options: ["1 ampere × 1 second", "1 volt × 1 second", "1 ohm × 1 second", "1 watt × 1 second"],
  answer: "1 ampere × 1 second"
},
{
  question: "Ohm’s law is valid only when:",
  options: ["temperature is constant", "current is zero", "voltage is zero", "resistance is zero"],
  answer: "temperature is constant"
},
{
  question: "The unit of resistance is:",
  options: ["Ohm", "Volt", "Ampere", "Watt"],
  answer: "Ohm"
},
{
  question: "Which expression correctly represents electrical power?",
  options: ["P = VI", "P = IR", "P = V/R", "P = I/V"],
  answer: "P = VI"
},
{
  question: "Which of the following represents electrical energy?",
  options: ["E = VIt", "E = IR", "E = V/R", "E = I/V"],
  answer: "E = VIt"
},
{
  question: "In a series circuit, the total resistance is:",
  options: ["sum of individual resistances", "product of resistances", "same as one resistor", "less than each resistor"],
  answer: "sum of individual resistances"
},
{
  question: "In a parallel circuit, the effective resistance is:",
  options: ["less than the smallest resistor", "greater than all resistors", "equal to sum", "equal to largest resistor"],
  answer: "less than the smallest resistor"
},
{
  question: "Which instrument is used to measure current?",
  options: ["Ammeter", "Voltmeter", "Ohmmeter", "Galvanometer"],
  answer: "Ammeter"
},
{
  question: "Which instrument is connected in parallel in a circuit?",
  options: ["Voltmeter", "Ammeter", "Resistor", "Battery"],
  answer: "Voltmeter"
},
{
  question: "Which factor affects resistance of a conductor?",
  options: ["Length of conductor", "Color of conductor", "Shape of battery", "Position in circuit"],
  answer: "Length of conductor"
},
{
  question: "If the length of a wire is doubled, its resistance:",
  options: ["doubles", "halves", "remains constant", "quadruples"],
  answer: "doubles"
},
{
  question: "Which material has the lowest resistance?",
  options: ["Copper", "Rubber", "Glass", "Plastic"],
  answer: "Copper"
},
{
  question: "A fuse is used to:",
  options: ["protect circuit from excessive current", "increase voltage", "store energy", "reduce resistance"],
  answer: "protect circuit from excessive current"
},
{
  question: "Electrical energy is measured in:",
  options: ["Joule", "Watt", "Volt", "Ohm"],
  answer: "Joule"
},
{
  question: "Which of the following is a good insulator?",
  options: ["Plastic", "Copper", "Aluminium", "Iron"],
  answer: "Plastic"
},
{
  question: "If voltage increases while resistance remains constant, current:",
  options: ["increases", "decreases", "remains constant", "becomes zero"],
  answer: "increases"
},
{
  question: "Which of the following best explains heating in a resistor?",
  options: ["conversion of electrical energy to heat", "loss of electrons", "increase in resistance only", "decrease in voltage"],
  answer: "conversion of electrical energy to heat"
},
{
  question: "Which device converts electrical energy into mechanical energy?",
  options: ["Electric motor", "Generator", "Transformer", "Battery"],
  answer: "Electric motor"
},

{
  question: "A magnetic field is best described as a region where:",
  options: ["a magnetic force can be detected", "electric current flows", "heat is produced", "light travels"],
  answer: "a magnetic force can be detected"
},
{
  question: "Magnetic field lines around a bar magnet run from:",
  options: ["North pole to South pole", "South pole to North pole", "Centre outward", "Random directions"],
  answer: "North pole to South pole"
},
{
  question: "Which material is strongly attracted to a magnet?",
  options: ["Iron", "Aluminium", "Copper", "Plastic"],
  answer: "Iron"
},
{
  question: "Like poles of magnets:",
  options: ["repel each other", "attract each other", "cancel each other", "have no effect"],
  answer: "repel each other"
},
{
  question: "Unlike poles of magnets:",
  options: ["attract each other", "repel each other", "neutralize", "do nothing"],
  answer: "attract each other"
},
{
  question: "Which device is used to detect the presence of a magnetic field?",
  options: ["Compass", "Voltmeter", "Ammeter", "Thermometer"],
  answer: "Compass"
},
{
  question: "An electromagnet is formed when current flows through a:",
  options: ["coil of wire", "metal plate", "plastic rod", "glass tube"],
  answer: "coil of wire"
},
{
  question: "The strength of an electromagnet can be increased by:",
  options: ["increasing current", "reducing turns", "using plastic core", "reducing voltage"],
  answer: "increasing current"
},
{
  question: "Which core material increases the strength of an electromagnet?",
  options: ["Soft iron", "Copper", "Aluminium", "Plastic"],
  answer: "Soft iron"
},
{
  question: "The direction of magnetic field around a current-carrying conductor is given by:",
  options: ["Right-hand grip rule", "Newton’s law", "Ohm’s law", "Archimedes principle"],
  answer: "Right-hand grip rule"
},
{
  question: "When a current-carrying conductor is placed in a magnetic field, it experiences:",
  options: ["a force", "heat only", "no effect", "pressure"],
  answer: "a force"
},
{
  question: "The direction of force on a current-carrying conductor is given by:",
  options: ["Fleming’s left-hand rule", "Right-hand rule", "Ohm’s law", "Lenz’s law"],
  answer: "Fleming’s left-hand rule"
},
{
  question: "Electromagnetic induction occurs when:",
  options: ["a conductor cuts magnetic field lines", "current is constant", "voltage is zero", "resistance is high"],
  answer: "a conductor cuts magnetic field lines"
},
{
  question: "The direction of induced current is given by:",
  options: ["Fleming’s right-hand rule", "Left-hand rule", "Ohm’s law", "Newton’s law"],
  answer: "Fleming’s right-hand rule"
},
{
  question: "Which device works on the principle of electromagnetic induction?",
  options: ["Generator", "Motor", "Battery", "Resistor"],
  answer: "Generator"
},
{
  question: "A transformer works on the principle of:",
  options: ["electromagnetic induction", "conduction", "radiation", "electrostatics"],
  answer: "electromagnetic induction"
},
{
  question: "A step-up transformer:",
  options: ["increases voltage", "decreases voltage", "reduces current only", "increases resistance"],
  answer: "increases voltage"
},
{
  question: "Which of the following remains constant in an ideal transformer?",
  options: ["Power", "Voltage", "Current", "Resistance"],
  answer: "Power"
},
{
  question: "Induced current is maximum when:",
  options: ["rate of change of magnetic field is high", "field is constant", "conductor is stationary", "temperature is low"],
  answer: "rate of change of magnetic field is high"
},
{
  question: "Which of the following is an application of electromagnets?",
  options: ["Electric bell", "Thermometer", "Barometer", "Hydrometer"],
  answer: "Electric bell"
},

{
  question: "An atom consists of:",
  options: ["protons, neutrons and electrons", "only protons and electrons", "only neutrons", "only electrons"],
  answer: "protons, neutrons and electrons"
},
{
  question: "The atomic number of an element represents the number of:",
  options: ["protons", "neutrons", "electrons only", "nucleons"],
  answer: "protons"
},
{
  question: "Isotopes of an element have the same:",
  options: ["atomic number but different mass numbers", "mass number only", "number of neutrons", "number of nucleons"],
  answer: "atomic number but different mass numbers"
},
{
  question: "Which radiation has the greatest penetrating power?",
  options: ["Gamma rays", "Beta particles", "Alpha particles", "X-rays"],
  answer: "Gamma rays"
},
{
  question: "Which radiation is deflected most in an electric field?",
  options: ["Beta particles", "Alpha particles", "Gamma rays", "Neutrons"],
  answer: "Beta particles"
},
{
  question: "Alpha particles consist of:",
  options: ["2 protons and 2 neutrons", "electrons only", "photons", "protons only"],
  answer: "2 protons and 2 neutrons"
},
{
  question: "Beta particles are:",
  options: ["high-speed electrons", "helium nuclei", "protons", "neutrons"],
  answer: "high-speed electrons"
},
{
  question: "Gamma radiation is:",
  options: ["electromagnetic waves", "particles with mass", "protons", "electrons"],
  answer: "electromagnetic waves"
},
{
  question: "Half-life is defined as the time taken for:",
  options: ["half the nuclei to decay", "all nuclei to decay", "temperature to halve", "mass to double"],
  answer: "half the nuclei to decay"
},
{
  question: "Radioactive decay is a:",
  options: ["random process", "predictable process", "controlled reaction", "reversible reaction"],
  answer: "random process"
},
{
  question: "Which of the following changes during radioactive decay?",
  options: ["Nucleus", "Electron shell only", "Temperature", "Volume"],
  answer: "Nucleus"
},
{
  question: "Which radiation is stopped by paper?",
  options: ["Alpha", "Beta", "Gamma", "X-rays"],
  answer: "Alpha"
},
{
  question: "Which radiation requires thick lead shielding?",
  options: ["Gamma", "Alpha", "Beta", "Neutron"],
  answer: "Gamma"
},
{
  question: "The unit of radioactivity is:",
  options: ["Becquerel", "Joule", "Watt", "Newton"],
  answer: "Becquerel"
},
{
  question: "Nuclear fission involves:",
  options: ["splitting of a heavy nucleus", "combination of nuclei", "electron movement", "energy absorption only"],
  answer: "splitting of a heavy nucleus"
},
{
  question: "Nuclear fusion involves:",
  options: ["combining light nuclei", "splitting heavy nuclei", "electron transfer", "decay process"],
  answer: "combining light nuclei"
},
{
  question: "Which of the following occurs in the sun?",
  options: ["Nuclear fusion", "Nuclear fission", "Radioactive decay", "Chemical reaction"],
  answer: "Nuclear fusion"
},
{
  question: "Which of the following is a use of radioisotopes?",
  options: ["Medical diagnosis", "Mechanical work", "Heat conduction", "Electric current"],
  answer: "Medical diagnosis"
},
{
  question: "Which of the following is a hazard of radiation?",
  options: ["Damage to living cells", "Increase in temperature", "Improved conductivity", "Reduced pressure"],
  answer: "Damage to living cells"
},
{
  question: "Which of the following best explains nuclear stability?",
  options: ["Balance between nuclear forces", "Temperature of nucleus", "Color of atom", "Mass of electrons"],
  answer: "Balance between nuclear forces"
},

{
  question: "A semiconductor is a material whose conductivity is:",
  options: ["between that of a conductor and an insulator", "equal to a conductor", "equal to an insulator", "zero"],
  answer: "between that of a conductor and an insulator"
},
{
  question: "Which of the following is a semiconductor material?",
  options: ["Silicon", "Copper", "Rubber", "Glass"],
  answer: "Silicon"
},
{
  question: "Doping in semiconductors is the process of:",
  options: ["adding impurities to modify conductivity", "removing electrons", "heating material", "cooling material"],
  answer: "adding impurities to modify conductivity"
},
{
  question: "An N-type semiconductor has excess:",
  options: ["electrons", "holes", "protons", "neutrons"],
  answer: "electrons"
},
{
  question: "A P-type semiconductor has excess:",
  options: ["holes", "electrons", "protons", "neutrons"],
  answer: "holes"
},
{
  question: "A p-n junction forms the basis of a:",
  options: ["diode", "resistor", "capacitor", "inductor"],
  answer: "diode"
},
{
  question: "A diode allows current to flow in:",
  options: ["one direction only", "both directions equally", "no direction", "reverse direction only"],
  answer: "one direction only"
},
{
  question: "Forward biasing of a diode means:",
  options: ["reducing the barrier to allow current flow", "increasing resistance", "blocking current", "reducing voltage"],
  answer: "reducing the barrier to allow current flow"
},
{
  question: "Reverse biasing of a diode results in:",
  options: ["very small current flow", "large current flow", "zero resistance", "increased conduction"],
  answer: "very small current flow"
},
{
  question: "A diode is used in rectification to convert:",
  options: ["AC to DC", "DC to AC", "heat to electricity", "light to heat"],
  answer: "AC to DC"
},
{
  question: "Which device is used to amplify signals?",
  options: ["Transistor", "Diode", "Resistor", "Capacitor"],
  answer: "Transistor"
},
{
  question: "A transistor has three terminals called:",
  options: ["emitter, base, collector", "anode, cathode, grid", "input, output, ground", "source, drain, gate"],
  answer: "emitter, base, collector"
},
{
  question: "In a transistor, the base controls:",
  options: ["current flow between emitter and collector", "voltage only", "resistance only", "temperature"],
  answer: "current flow between emitter and collector"
},
{
  question: "Which of the following best explains amplification?",
  options: ["increase in signal strength", "decrease in voltage", "reduction in current", "loss of energy"],
  answer: "increase in signal strength"
},
{
  question: "Which component stores electrical charge?",
  options: ["Capacitor", "Resistor", "Inductor", "Diode"],
  answer: "Capacitor"
},
{
  question: "Which component opposes change in current?",
  options: ["Inductor", "Capacitor", "Resistor", "Diode"],
  answer: "Inductor"
},
{
  question: "A resistor is used to:",
  options: ["limit current", "store charge", "increase voltage", "generate power"],
  answer: "limit current"
},
{
  question: "Which device converts AC to DC in power supply circuits?",
  options: ["Rectifier", "Transformer", "Capacitor", "Inductor"],
  answer: "Rectifier"
},
{
  question: "Which of the following best explains the function of a capacitor in circuits?",
  options: ["smoothens output voltage", "increases resistance", "generates current", "reduces power"],
  answer: "smoothens output voltage"
},
{
  question: "Which of the following is a practical application of transistors?",
  options: ["Amplifiers in radios", "Thermometers", "Barometers", "Hydrometers"],
  answer: "Amplifiers in radios"
},

{
  question: "A body moving with constant speed in a circular path has acceleration because:",
  options: ["its direction of motion changes continuously", "its speed is increasing", "no force acts on it", "its velocity is constant"],
  answer: "its direction of motion changes continuously"
},
{
  question: "Which factor determines the magnitude of centripetal force?",
  options: ["mass, velocity and radius", "mass only", "radius only", "velocity only"],
  answer: "mass, velocity and radius"
},
{
  question: "A gas is compressed at constant temperature. Which quantity increases?",
  options: ["Pressure", "Volume", "Temperature", "Mass"],
  answer: "Pressure"
},
{
  question: "Which of the following explains why solids conduct heat better than gases?",
  options: ["Particles are closely packed", "Particles move faster", "Particles are larger", "Particles are lighter"],
  answer: "Particles are closely packed"
},
{
  question: "Which of the following best explains diffraction?",
  options: ["Spreading of waves when passing through a narrow gap", "Reflection of waves", "Refraction of waves", "Absorption of waves"],
  answer: "Spreading of waves when passing through a narrow gap"
},
{
  question: "Which property of waves determines their energy?",
  options: ["Amplitude", "Frequency", "Wavelength", "Speed"],
  answer: "Amplitude"
},
{
  question: "Which of the following explains why light refracts when entering another medium?",
  options: ["Change in speed", "Change in frequency", "Change in amplitude", "Change in source"],
  answer: "Change in speed"
},
{
  question: "A conductor has high resistance when:",
  options: ["its length is increased", "its thickness is increased", "temperature is decreased", "material is copper"],
  answer: "its length is increased"
},
{
  question: "Which of the following determines the current in a circuit?",
  options: ["Potential difference and resistance", "Voltage only", "Resistance only", "Power only"],
  answer: "Potential difference and resistance"
},
{
  question: "Which of the following explains why parallel circuits are used in homes?",
  options: ["devices operate independently", "current is zero", "voltage is reduced", "resistance is maximum"],
  answer: "devices operate independently"
},
{
  question: "Which of the following explains energy loss in machines?",
  options: ["Friction converts energy to heat", "Energy is destroyed", "Mass decreases", "Force disappears"],
  answer: "Friction converts energy to heat"
},
{
  question: "A body falls freely under gravity. Its acceleration is:",
  options: ["constant", "increasing", "decreasing", "zero"],
  answer: "constant"
},
{
  question: "Which of the following explains why pressure increases with depth in liquids?",
  options: ["weight of liquid above increases", "temperature increases", "volume increases", "density decreases"],
  answer: "weight of liquid above increases"
},
{
  question: "Which of the following best explains resonance?",
  options: ["system vibrates with maximum amplitude at natural frequency", "waves cancel each other", "energy is lost", "frequency decreases"],
  answer: "system vibrates with maximum amplitude at natural frequency"
},
{
  question: "Which of the following best explains how transformers reduce energy loss?",
  options: ["high voltage reduces current", "low voltage increases current", "resistance is zero", "power is reduced"],
  answer: "high voltage reduces current"
},
{
  question: "Which of the following explains why metals expand when heated?",
  options: ["increase in kinetic energy of particles", "decrease in particle size", "loss of electrons", "formation of bonds"],
  answer: "increase in kinetic energy of particles"
},
{
  question: "Which of the following determines the loudness of sound?",
  options: ["Amplitude", "Frequency", "Speed", "Wavelength"],
  answer: "Amplitude"
},
{
  question: "Which of the following explains the motion of projectiles?",
  options: ["combination of horizontal and vertical motion", "circular motion only", "linear motion only", "random motion"],
  answer: "combination of horizontal and vertical motion"
},
{
  question: "Which of the following best explains induced current?",
  options: ["change in magnetic flux", "constant magnetic field", "increase in resistance", "increase in voltage only"],
  answer: "change in magnetic flux"
},
{
  question: "Which of the following explains why insulators do not conduct electricity?",
  options: ["lack of free electrons", "high density", "high temperature", "large size"],
  answer: "lack of free electrons"
},

{
  question: "A projectile is launched at an angle θ. At the highest point, its horizontal velocity is:",
  options: ["constant", "zero", "maximum", "increasing"],
  answer: "constant"
},
{
  question: "The time of flight of a projectile depends on:",
  options: ["vertical component of velocity", "horizontal velocity", "mass", "range only"],
  answer: "vertical component of velocity"
},
{
  question: "The range of a projectile is maximum when the angle of projection is:",
  options: ["45°", "30°", "60°", "90°"],
  answer: "45°"
},
{
  question: "Two projectiles are fired at complementary angles. Their ranges are:",
  options: ["equal", "different", "zero", "independent"],
  answer: "equal"
},
{
  question: "Moment of a force is defined as:",
  options: ["force × perpendicular distance", "force × velocity", "mass × acceleration", "force ÷ distance"],
  answer: "force × perpendicular distance"
},
{
  question: "The SI unit of moment is:",
  options: ["N m", "N", "J", "W"],
  answer: "N m"
},
{
  question: "For a body in equilibrium, the sum of moments about a point is:",
  options: ["zero", "maximum", "minimum", "constant"],
  answer: "zero"
},
{
  question: "Which condition is required for equilibrium?",
  options: ["net force and net moment are zero", "force only is zero", "moment only is zero", "velocity is zero"],
  answer: "net force and net moment are zero"
},
{
  question: "Pressure is defined as:",
  options: ["force per unit area", "force × area", "mass per unit volume", "force × distance"],
  answer: "force per unit area"
},
{
  question: "The SI unit of pressure is:",
  options: ["Pascal", "Newton", "Joule", "Watt"],
  answer: "Pascal"
},
{
  question: "Pressure in a liquid increases with:",
  options: ["depth", "surface area", "temperature", "volume"],
  answer: "depth"
},
{
  question: "Upthrust on a body in fluid is equal to:",
  options: ["weight of fluid displaced", "mass of fluid", "volume of fluid", "density only"],
  answer: "weight of fluid displaced"
},
{
  question: "A body floats when:",
  options: ["upthrust equals weight", "weight is greater", "density is zero", "volume is constant"],
  answer: "upthrust equals weight"
},
{
  question: "The refractive index of a medium is:",
  options: ["speed in vacuum ÷ speed in medium", "speed in medium ÷ speed in vacuum", "wavelength ÷ frequency", "frequency × wavelength"],
  answer: "speed in vacuum ÷ speed in medium"
},
{
  question: "When light passes from air into glass, it:",
  options: ["slows down and bends towards normal", "speeds up and bends away", "does not change", "reflects completely"],
  answer: "slows down and bends towards normal"
},
{
  question: "The critical angle is defined as the angle of incidence when:",
  options: ["angle of refraction is 90°", "reflection occurs", "angle is zero", "refraction is maximum"],
  answer: "angle of refraction is 90°"
},
{
  question: "A convex lens produces a real image when the object is:",
  options: ["beyond focal length", "at focal point", "within focal length", "at infinity only"],
  answer: "beyond focal length"
},
{
  question: "The power of a lens is measured in:",
  options: ["dioptre", "metre", "watt", "joule"],
  answer: "dioptre"
},
{
  question: "Power of a lens is given by:",
  options: ["1/f", "f", "f²", "1/f²"],
  answer: "1/f"
},
{
  question: "Which of the following best explains floating?",
  options: ["density of object is less than fluid", "mass is zero", "pressure is constant", "volume is zero"],
  answer: "density of object is less than fluid"
},

{
  question: "The slope of a velocity-time graph represents:",
  options: ["acceleration", "displacement", "speed", "distance"],
  answer: "acceleration"
},
{
  question: "The area under a force-time graph represents:",
  options: ["impulse", "work", "power", "energy"],
  answer: "impulse"
},
{
  question: "A car moves with increasing velocity at a decreasing rate. The acceleration is:",
  options: ["positive but decreasing", "negative", "constant", "zero"],
  answer: "positive but decreasing"
},
{
  question: "Which graph represents uniform motion?",
  options: ["straight line displacement-time graph", "curved velocity-time graph", "horizontal velocity-time graph at zero", "vertical displacement-time graph"],
  answer: "straight line displacement-time graph"
},
{
  question: "A body of mass 4 kg moving at 5 m/s is brought to rest in 2 s. The force applied is:",
  options: ["-10 N", "-20 N", "-5 N", "-40 N"],
  answer: "-10 N"
},
{
  question: "Which of the following best explains terminal velocity?",
  options: ["drag force equals weight", "acceleration is maximum", "velocity is zero", "force is zero"],
  answer: "drag force equals weight"
},
{
  question: "Which factor affects heat transfer by radiation?",
  options: ["surface nature", "mass of object", "volume only", "density only"],
  answer: "surface nature"
},
{
  question: "Which gas law involves constant pressure?",
  options: ["Charles’ law", "Boyle’s law", "Pressure law", "Combined gas law"],
  answer: "Charles’ law"
},
{
  question: "A conductor has resistance 4Ω. If current is 2 A, voltage is:",
  options: ["8 V", "2 V", "6 V", "4 V"],
  answer: "8 V"
},
{
  question: "Which of the following increases current in a circuit?",
  options: ["decreasing resistance", "increasing resistance", "reducing voltage", "opening circuit"],
  answer: "decreasing resistance"
},
{
  question: "The energy stored in a stretched spring depends on:",
  options: ["extension", "mass only", "temperature", "density"],
  answer: "extension"
},
{
  question: "Which of the following best explains why pressure decreases with height?",
  options: ["less air above", "higher temperature", "more density", "stronger gravity"],
  answer: "less air above"
},
{
  question: "A ray of light passes from glass to air. It bends:",
  options: ["away from the normal", "towards the normal", "does not bend", "reflects fully"],
  answer: "away from the normal"
},
{
  question: "Which of the following determines the focal length of a lens?",
  options: ["curvature and material", "color", "size", "temperature"],
  answer: "curvature and material"
},
{
  question: "Which of the following explains induced emf?",
  options: ["change in magnetic flux", "constant current", "increase in resistance", "steady field"],
  answer: "change in magnetic flux"
},
{
  question: "A transformer reduces voltage from 240 V to 120 V. It is a:",
  options: ["step-down transformer", "step-up transformer", "rectifier", "generator"],
  answer: "step-down transformer"
},
{
  question: "Which of the following determines wave speed?",
  options: ["medium properties", "frequency only", "amplitude", "time"],
  answer: "medium properties"
},
{
  question: "Which of the following best explains energy conservation in oscillations?",
  options: ["conversion between kinetic and potential energy", "energy is lost completely", "mass changes", "velocity is constant"],
  answer: "conversion between kinetic and potential energy"
},
{
  question: "A body immersed in fluid experiences upthrust because:",
  options: ["pressure difference", "temperature difference", "density decrease", "mass increase"],
  answer: "pressure difference"
},
{
  question: "Which of the following best explains why metals conduct electricity?",
  options: ["presence of free electrons", "high density", "strong bonds", "large atoms"],
  answer: "presence of free electrons"
},

{
  question: "A projectile is fired horizontally. Its vertical motion is:",
  options: ["uniformly accelerated", "uniform velocity", "zero motion", "decreasing acceleration"],
  answer: "uniformly accelerated"
},
{
  question: "Which condition ensures rotational equilibrium?",
  options: ["sum of clockwise moments equals anticlockwise moments", "force is maximum", "velocity is constant", "mass is zero"],
  answer: "sum of clockwise moments equals anticlockwise moments"
},
{
  question: "A gas expands at constant temperature. The internal energy:",
  options: ["remains constant", "increases", "decreases", "becomes zero"],
  answer: "remains constant"
},
{
  question: "Which factor most affects the rate of heat conduction?",
  options: ["thermal conductivity of material", "color of object", "mass only", "volume only"],
  answer: "thermal conductivity of material"
},
{
  question: "Which of the following explains total internal reflection?",
  options: ["light moves from denser to less dense medium beyond critical angle", "light reflects always", "light speeds up", "light stops"],
  answer: "light moves from denser to less dense medium beyond critical angle"
},
{
  question: "A convex lens forms a virtual image when the object is:",
  options: ["within focal length", "beyond focal length", "at focal point", "at infinity"],
  answer: "within focal length"
},
{
  question: "Which of the following best explains why parallel circuits are preferred in homes?",
  options: ["constant voltage across devices", "constant current only", "zero resistance", "no power loss"],
  answer: "constant voltage across devices"
},
{
  question: "A current-carrying conductor in a magnetic field experiences force due to:",
  options: ["interaction between magnetic fields", "temperature increase", "resistance only", "voltage change"],
  answer: "interaction between magnetic fields"
},
{
  question: "Which of the following determines the induced emf in a coil?",
  options: ["rate of change of magnetic flux", "resistance of coil", "temperature", "mass of coil"],
  answer: "rate of change of magnetic flux"
},
{
  question: "Which of the following explains why alpha particles are least penetrating?",
  options: ["large mass and charge", "no charge", "small size", "high speed"],
  answer: "large mass and charge"
},
{
  question: "A body moving with constant velocity has:",
  options: ["zero resultant force", "increasing force", "maximum acceleration", "decreasing mass"],
  answer: "zero resultant force"
},
{
  question: "Which of the following explains why friction is sometimes useful?",
  options: ["provides grip", "reduces motion always", "destroys energy", "increases mass"],
  answer: "provides grip"
},
{
  question: "A transformer increases voltage but power remains constant. Current will:",
  options: ["decrease", "increase", "remain same", "be zero"],
  answer: "decrease"
},
{
  question: "Which of the following best explains resonance in a system?",
  options: ["maximum energy transfer at natural frequency", "minimum vibration", "no energy transfer", "constant amplitude"],
  answer: "maximum energy transfer at natural frequency"
},
{
  question: "Which factor affects pressure in gases directly?",
  options: ["collision rate of particles", "color of gas", "shape of container", "volume only"],
  answer: "collision rate of particles"
},
{
  question: "Which of the following best explains diffraction of light?",
  options: ["bending of waves around obstacles", "reflection of waves", "absorption of waves", "straight-line motion"],
  answer: "bending of waves around obstacles"
},
{
  question: "A floating body displaces liquid equal to its:",
  options: ["weight", "volume", "density", "mass"],
  answer: "weight"
},
{
  question: "Which of the following determines electrical resistance?",
  options: ["material and dimensions", "color only", "temperature only", "mass only"],
  answer: "material and dimensions"
},
{
  question: "Which of the following explains why sound waves cannot travel in vacuum?",
  options: ["no medium for vibration", "no energy", "high speed", "low frequency"],
  answer: "no medium for vibration"
},
{
  question: "Which of the following best explains energy transformation in a generator?",
  options: ["mechanical to electrical energy", "electrical to mechanical", "chemical to thermal", "thermal to electrical"],
  answer: "mechanical to electrical energy"
},

{
  question: "A projectile is fired with velocity u at angle θ. Its maximum height depends on:",
  options: ["vertical component of velocity", "horizontal component", "mass only", "time only"],
  answer: "vertical component of velocity"
},
{
  question: "A body of mass 3 kg moving at 6 m/s collides and stops in 0.5 s. The average force is:",
  options: ["-36 N", "-18 N", "-12 N", "-9 N"],
  answer: "-36 N"
},
{
  question: "A body is in equilibrium under three forces. These forces must be:",
  options: ["coplanar and concurrent", "parallel", "equal only", "perpendicular"],
  answer: "coplanar and concurrent"
},
{
  question: "Which factor affects the efficiency of a machine most?",
  options: ["energy losses due to friction", "color", "size only", "mass only"],
  answer: "energy losses due to friction"
},
{
  question: "A gas occupies 2 m³ at pressure 100 kPa. If compressed to 1 m³, new pressure is:",
  options: ["200 kPa", "100 kPa", "50 kPa", "300 kPa"],
  answer: "200 kPa"
},
{
  question: "Which process transfers heat without a medium?",
  options: ["Radiation", "Conduction", "Convection", "Evaporation"],
  answer: "Radiation"
},
{
  question: "A ray of light enters glass at 30°. If refractive index is 1.5, the angle of refraction is closest to:",
  options: ["19°", "25°", "30°", "15°"],
  answer: "19°"
},
{
  question: "The focal length of a lens is 0.5 m. Its power is:",
  options: ["2 D", "-2 D", "0.5 D", "1 D"],
  answer: "2 D"
},
{
  question: "Which factor determines wave frequency?",
  options: ["source of vibration", "medium", "amplitude", "speed"],
  answer: "source of vibration"
},
{
  question: "A resistor of 10Ω carries 2 A current. Power dissipated is:",
  options: ["40 W", "20 W", "10 W", "80 W"],
  answer: "40 W"
},
{
  question: "Which of the following reduces power loss in transmission lines?",
  options: ["high voltage transmission", "low voltage", "high resistance", "low current only"],
  answer: "high voltage transmission"
},
{
  question: "A conductor moves perpendicular to magnetic field. Induced emf is maximum when:",
  options: ["velocity is maximum", "velocity is zero", "field is constant", "resistance is high"],
  answer: "velocity is maximum"
},
{
  question: "Half-life of a substance is 10 years. Fraction remaining after 20 years is:",
  options: ["1/4", "1/2", "1/8", "3/4"],
  answer: "1/4"
},
{
  question: "Which radiation has no charge?",
  options: ["Gamma", "Alpha", "Beta", "Proton"],
  answer: "Gamma"
},
{
  question: "Which component allows current flow in one direction?",
  options: ["Diode", "Resistor", "Capacitor", "Inductor"],
  answer: "Diode"
},
{
  question: "A transistor amplifies signals by:",
  options: ["increasing current or voltage", "reducing resistance", "storing charge", "blocking current"],
  answer: "increasing current or voltage"
},
{
  question: "Which factor affects terminal velocity?",
  options: ["air resistance and weight", "color", "temperature only", "volume only"],
  answer: "air resistance and weight"
},
{
  question: "A body immersed fully in fluid experiences upthrust equal to:",
  options: ["weight of displaced fluid", "mass of fluid", "volume only", "density only"],
  answer: "weight of displaced fluid"
},
{
  question: "Which law explains conservation of momentum?",
  options: ["Newton’s third law", "First law", "Second law", "Ohm’s law"],
  answer: "Newton’s third law"
},
{
  question: "Which of the following best explains energy transformation in solar cells?",
  options: ["light to electrical energy", "heat to mechanical", "chemical to thermal", "electrical to light"],
  answer: "light to electrical energy"
},

{
  question: "A car accelerates uniformly from 10 m/s to 30 m/s in 5 s. Distance covered is:",
  options: ["100 m", "80 m", "120 m", "150 m"],
  answer: "100 m"
},
{
  question: "A force of 15 N acts at 60° to the horizontal. The horizontal component is closest to:",
  options: ["7.5 N", "13 N", "15 N", "10 N"],
  answer: "7.5 N"
},
{
  question: "A body of mass 2 kg is lifted to height 10 m. Gain in potential energy is (g = 10 m/s²):",
  options: ["200 J", "100 J", "50 J", "20 J"],
  answer: "200 J"
},
{
  question: "A machine has MA = 4 and VR = 5. Efficiency is:",
  options: ["80%", "20%", "125%", "50%"],
  answer: "80%"
},
{
  question: "A gas expands from 1 m³ to 3 m³ at constant pressure. Work done is proportional to:",
  options: ["change in volume", "pressure only", "temperature", "mass"],
  answer: "change in volume"
},
{
  question: "Which factor increases rate of heat loss from a body?",
  options: ["increase in surface area", "decrease in temperature difference", "smooth shiny surface", "vacuum"],
  answer: "increase in surface area"
},
{
  question: "A wave has frequency 500 Hz and wavelength 0.6 m. Its speed is:",
  options: ["300 m/s", "200 m/s", "600 m/s", "100 m/s"],
  answer: "300 m/s"
},
{
  question: "A ray enters glass with angle 45°. If n = 1.5, refracted angle is closest to:",
  options: ["28°", "30°", "45°", "20°"],
  answer: "28°"
},
{
  question: "Two resistors 6Ω and 3Ω are in parallel. Equivalent resistance is:",
  options: ["2Ω", "9Ω", "3Ω", "1Ω"],
  answer: "2Ω"
},
{
  question: "A device uses 240 V and 2 A. Power consumed is:",
  options: ["480 W", "120 W", "240 W", "60 W"],
  answer: "480 W"
},
{
  question: "Which condition increases induced emf?",
  options: ["faster change in magnetic field", "constant field", "low current", "high resistance"],
  answer: "faster change in magnetic field"
},
{
  question: "Half-life is 5 years. Fraction remaining after 15 years:",
  options: ["1/8", "1/4", "1/2", "3/4"],
  answer: "1/8"
},
{
  question: "Which radiation is most ionizing?",
  options: ["Alpha", "Beta", "Gamma", "X-ray"],
  answer: "Alpha"
},
{
  question: "Which component smooths pulsating DC output?",
  options: ["Capacitor", "Resistor", "Inductor", "Diode"],
  answer: "Capacitor"
},
{
  question: "Which factor affects terminal velocity most?",
  options: ["cross-sectional area", "color", "mass only", "temperature"],
  answer: "cross-sectional area"
},
{
  question: "A floating object has density compared to fluid:",
  options: ["less than fluid", "equal always", "greater always", "zero"],
  answer: "less than fluid"
},
{
  question: "Which law relates pressure and volume inversely?",
  options: ["Boyle’s law", "Charles’ law", "Ohm’s law", "Newton’s law"],
  answer: "Boyle’s law"
},
{
  question: "Which of the following explains why lenses focus light?",
  options: ["refraction at curved surfaces", "reflection only", "absorption", "diffraction only"],
  answer: "refraction at curved surfaces"
},
{
  question: "A current of 3 A flows for 5 s. Charge transferred is:",
  options: ["15 C", "8 C", "3 C", "5 C"],
  answer: "15 C"
},
{
  question: "Which energy conversion occurs in a generator?",
  options: ["mechanical to electrical", "electrical to mechanical", "chemical to electrical", "thermal to electrical"],
  answer: "mechanical to electrical"
},

{
  question: "A car travels with initial velocity 5 m/s and accelerates at 2 m/s² for 10 s. Final velocity is:",
  options: ["25 m/s", "20 m/s", "15 m/s", "30 m/s"],
  answer: "25 m/s"
},
{
  question: "Resultant of two perpendicular forces 9 N and 12 N is:",
  options: ["15 N", "21 N", "3 N", "108 N"],
  answer: "15 N"
},
{
  question: "Work done lifting 50 N load through 2 m is:",
  options: ["100 J", "25 J", "50 J", "200 J"],
  answer: "100 J"
},
{
  question: "Efficiency = 60%, input = 500 J. Useful output:",
  options: ["300 J", "200 J", "400 J", "100 J"],
  answer: "300 J"
},
{
  question: "Which increases pressure in gas?",
  options: ["increase temperature", "increase volume", "decrease mass", "decrease density"],
  answer: "increase temperature"
},
{
  question: "A body cools faster when:",
  options: ["temperature difference is large", "surface is shiny", "area is small", "vacuum"],
  answer: "temperature difference is large"
},
{
  question: "Wave with frequency 1000 Hz and speed 340 m/s has wavelength:",
  options: ["0.34 m", "3.4 m", "34 m", "0.034 m"],
  answer: "0.34 m"
},
{
  question: "Critical angle depends on:",
  options: ["refractive index", "frequency", "wavelength", "speed only"],
  answer: "refractive index"
},
{
  question: "Three resistors in series 2Ω, 3Ω, 5Ω. Total resistance:",
  options: ["10Ω", "30Ω", "5Ω", "2Ω"],
  answer: "10Ω"
},
{
  question: "Current 4 A flows in 10Ω resistor. Voltage:",
  options: ["40 V", "10 V", "4 V", "20 V"],
  answer: "40 V"
},
{
  question: "Magnetic field strength increases with:",
  options: ["current", "length", "resistance", "temperature"],
  answer: "current"
},
{
  question: "Transformer reduces voltage → current:",
  options: ["increases", "decreases", "same", "zero"],
  answer: "increases"
},
{
  question: "Half-life 2 years. After 6 years remains:",
  options: ["1/8", "1/2", "1/4", "3/4"],
  answer: "1/8"
},
{
  question: "Beta particles are:",
  options: ["electrons", "protons", "neutrons", "photons"],
  answer: "electrons"
},
{
  question: "Diode in reverse bias:",
  options: ["blocks current", "allows full current", "increases voltage", "stores charge"],
  answer: "blocks current"
},
{
  question: "Transistor used as:",
  options: ["amplifier", "heater", "insulator", "generator"],
  answer: "amplifier"
},
{
  question: "Terminal velocity occurs when:",
  options: ["net force zero", "acceleration max", "speed zero", "weight zero"],
  answer: "net force zero"
},
{
  question: "Upthrust depends on:",
  options: ["density of fluid", "mass only", "volume only", "temperature"],
  answer: "density of fluid"
},
{
  question: "Momentum conserved when:",
  options: ["no external force", "force exists", "energy increases", "mass changes"],
  answer: "no external force"
},
{
  question: "Solar cell converts:",
  options: ["light to electricity", "heat to light", "mechanical to electrical", "chemical to heat"],
  answer: "light to electricity"
},

{
  question: "Acceleration is rate of change of:",
  options: ["velocity", "distance", "force", "energy"],
  answer: "velocity"
},
{
  question: "A body in motion remains so unless acted upon by:",
  options: ["external force", "mass", "energy", "velocity"],
  answer: "external force"
},
{
  question: "Energy stored in raised object is:",
  options: ["potential energy", "kinetic energy", "heat energy", "electrical energy"],
  answer: "potential energy"
},
{
  question: "Heat transfer in solids mainly by:",
  options: ["conduction", "convection", "radiation", "evaporation"],
  answer: "conduction"
},
{
  question: "Sound requires:",
  options: ["medium", "vacuum", "light", "heat"],
  answer: "medium"
},
{
  question: "Mirror forms image by:",
  options: ["reflection", "refraction", "diffraction", "absorption"],
  answer: "reflection"
},
{
  question: "Parallel circuits share:",
  options: ["same voltage", "same current", "same resistance", "same power"],
  answer: "same voltage"
},
{
  question: "Magnetism arises from:",
  options: ["moving charges", "heat", "pressure", "mass"],
  answer: "moving charges"
},
{
  question: "Induced current needs:",
  options: ["changing magnetic field", "constant field", "no field", "high resistance"],
  answer: "changing magnetic field"
},
{
  question: "Gamma rays are:",
  options: ["electromagnetic", "particles", "protons", "neutrons"],
  answer: "electromagnetic"
},
{
  question: "Capacitor stores:",
  options: ["charge", "current", "voltage", "power"],
  answer: "charge"
},
{
  question: "Resistor limits:",
  options: ["current", "voltage", "power", "charge"],
  answer: "current"
},
{
  question: "Inductor opposes change in:",
  options: ["current", "voltage", "charge", "energy"],
  answer: "current"
},
{
  question: "Density =:",
  options: ["mass/volume", "volume/mass", "force/area", "mass×volume"],
  answer: "mass/volume"
},
{
  question: "Pressure =:",
  options: ["force/area", "mass/volume", "force×distance", "energy/time"],
  answer: "force/area"
},
{
  question: "Power =:",
  options: ["work/time", "force×distance", "mass×velocity", "energy×time"],
  answer: "work/time"
},
{
  question: "Frequency unit:",
  options: ["Hz", "m", "s", "J"],
  answer: "Hz"
},
{
  question: "Wave speed =:",
  options: ["fλ", "λ/f", "f/λ", "λ×t"],
  answer: "fλ"
},
{
  question: "Charge =:",
  options: ["It", "V/R", "IR", "P/t"],
  answer: "It"
},
{
  question: "Ohm’s law:",
  options: ["V = IR", "P = IV", "E = mc²", "F = ma"],
  answer: "V = IR"
},

{
  question: "The diagram shows a velocity-time graph of a particle. Calculate the total distance travelled.",
  image: "/images/physics1.png",
  options: ["20 m", "40 m", "60 m", "80 m"],
  answer: "60 m"
},

{
  question: "The diagram shows a displacement-time graph. What does the slope at a point represent?",
  image: "/images/physics2.png",
  options: ["Acceleration", "Velocity", "Force", "Energy"],
  answer: "Velocity"
},

{
  question: "A body starts from rest and accelerates uniformly at 3 m/sÂ² for 4 s. Using the diagram, find the velocity.",
  image: "/images/physics3.png",
  options: ["12 m/s", "6 m/s", "8 m/s", "10 m/s"],
  answer: "12 m/s"
},

{
  question: "The diagram shows a velocity-time graph with a triangular shape. Find the acceleration.",
  image: "/images/physics4.png",
  options: ["2 m/sÂ²", "4 m/sÂ²", "6 m/sÂ²", "8 m/sÂ²"],
  answer: "2 m/sÂ²"
},

{
  question: "A car moves with constant acceleration. From the diagram, determine the area under the graph.",
  image: "/images/physics5.png",
  options: ["Distance", "Velocity", "Acceleration", "Force"],
  answer: "Distance"
},

{
  question: "The diagram shows two forces acting at right angles. Find the resultant force.",
  image: "/images/physics6.png",
  options: ["5 N", "7 N", "6 N", "4 N"],
  answer: "5 N"
},

{
  question: "A body of mass 2 kg is acted upon by a force as shown in the diagram. Find the acceleration.",
  image: "/images/physics7.png",
  options: ["2 m/sÂ²", "3 m/sÂ²", "4 m/sÂ²", "5 m/sÂ²"],
  answer: "3 m/sÂ²"
},

{
  question: "The diagram shows a free fall motion. What is the acceleration due to gravity?",
  image: "/images/physics8.png",
  options: ["9.8 m/sÂ²", "10 m/sÂ²", "8 m/sÂ²", "12 m/sÂ²"],
  answer: "9.8 m/sÂ²"
},

{
  question: "The diagram shows a velocity-time graph with constant velocity. What is the acceleration?",
  image: "/images/physics9.png",
  options: ["0", "1 m/sÂ²", "2 m/sÂ²", "3 m/sÂ²"],
  answer: "0"
},

{
  question: "A force acts on a body for a short time as shown in the diagram. What quantity is represented by the area?",
  image: "/images/physics10.png",
  options: ["Momentum", "Impulse", "Force", "Energy"],
  answer: "Impulse"
},

{
  question: "The diagram shows a beam balanced on a pivot. If a force of 10 N acts at 2 m on one side, what force is needed at 1 m on the other side for equilibrium?",
  image: "/images/physics11.png",
  options: ["5 N", "10 N", "20 N", "40 N"],
  answer: "20 N"
},

{
  question: "The diagram shows a uniform rod in equilibrium. The sum of clockwise moments is equal to:",
  image: "/images/physics12.png",
  options: ["Anticlockwise moments", "Weight", "Force", "Mass"],
  answer: "Anticlockwise moments"
},

{
  question: "A force acts on a body causing acceleration. If mass is doubled, what happens to acceleration (same force)?",
  image: "/images/physics13.png",
  options: ["Doubles", "Halves", "Remains same", "Becomes zero"],
  answer: "Halves"
},

{
  question: "The diagram shows a block on a rough surface. The force opposing motion is:",
  image: "/images/physics14.png",
  options: ["Friction", "Gravity", "Upthrust", "Magnetic force"],
  answer: "Friction"
},

{
  question: "The diagram shows pressure acting on a surface. If area increases, pressure will:",
  image: "/images/physics15.png",
  options: ["Increase", "Decrease", "Remain constant", "Become zero"],
  answer: "Decrease"
},

{
  question: "A force of 50 N acts on an area of 10 mÂ². Find the pressure.",
  image: "/images/physics16.png",
  options: ["5 Pa", "50 Pa", "500 Pa", "0.2 Pa"],
  answer: "5 Pa"
},

{
  question: "The diagram shows an object immersed in liquid. The upward force acting on it is called:",
  image: "/images/physics17.png",
  options: ["Upthrust", "Friction", "Weight", "Pressure"],
  answer: "Upthrust"
},

{
  question: "An object floats in water. What is true about upthrust and weight?",
  image: "/images/physics18.png",
  options: ["Upthrust > Weight", "Upthrust = Weight", "Upthrust < Weight", "No upthrust"],
  answer: "Upthrust = Weight"
},

{
  question: "The diagram shows a hydraulic press. Pressure applied is transmitted equally due to:",
  image: "/images/physics19.png",
  options: ["Pascalâ€™s principle", "Newtonâ€™s law", "Ohmâ€™s law", "Hookeâ€™s law"],
  answer: "Pascalâ€™s principle"
},

{
  question: "A force of 100 N is applied to a small piston of area 2 mÂ². Find pressure transmitted.",
  image: "/images/physics20.png",
  options: ["50 Pa", "200 Pa", "100 Pa", "20 Pa"],
  answer: "50 Pa"
},

{
  question: "The diagram shows a wave. What is the distance between two successive crests called?",
  image: "/images/physics21.png",
  options: ["Amplitude", "Wavelength", "Frequency", "Period"],
  answer: "Wavelength"
},

{
  question: "The diagram shows a transverse wave. The maximum displacement from equilibrium is:",
  image: "/images/physics22.png",
  options: ["Amplitude", "Wavelength", "Speed", "Frequency"],
  answer: "Amplitude"
},

{
  question: "The diagram shows a light ray incident on a plane mirror. The angle of incidence is 30Â°. Find the angle of reflection.",
  image: "/images/physics23.png",
  options: ["30Â°", "60Â°", "90Â°", "45Â°"],
  answer: "30Â°"
},

{
  question: "The diagram shows reflection of light. The incident ray, reflected ray and normal all lie in:",
  image: "/images/physics24.png",
  options: ["Same plane", "Different planes", "Circle", "Line"],
  answer: "Same plane"
},

{
  question: "The diagram shows refraction from air into water. What happens to the speed of light?",
  image: "/images/physics25.png",
  options: ["Increases", "Decreases", "Remains same", "Becomes zero"],
  answer: "Decreases"
},

{
  question: "The diagram shows a ray entering a glass block. It bends towards the normal. What does this indicate?",
  image: "/images/physics26.png",
  options: ["Denser medium", "Less dense medium", "No change", "Reflection"],
  answer: "Denser medium"
},

{
  question: "The diagram shows a convex lens forming an image. If object is beyond 2F, the image formed is:",
  image: "/images/physics27.png",
  options: ["Real and inverted", "Virtual and upright", "Same size", "No image"],
  answer: "Real and inverted"
},

{
  question: "The diagram shows a concave mirror. Parallel rays converge at a point called:",
  image: "/images/physics28.png",
  options: ["Focus", "Center", "Pole", "Vertex"],
  answer: "Focus"
},

{
  question: "The diagram shows wave motion. If frequency increases, wavelength will:",
  image: "/images/physics29.png",
  options: ["Decrease", "Increase", "Remain same", "Double"],
  answer: "Decrease"
},

{
  question: "The diagram shows a ripple tank. Wavefronts are represented by:",
  image: "/images/physics30.png",
  options: ["Lines", "Points", "Circles", "Dots"],
  answer: "Lines"
},

{
  question: "The diagram shows a simple circuit with a resistor and battery. If current is 2 A and resistance is 5 Î©, find the voltage.",
  image: "/images/physics31.png",
  options: ["10 V", "2.5 V", "5 V", "7 V"],
  answer: "10 V"
},

{
  question: "The diagram shows resistors in series. If Râ‚ = 2 Î© and Râ‚‚ = 3 Î©, find total resistance.",
  image: "/images/physics32.png",
  options: ["5 Î©", "6 Î©", "1 Î©", "2 Î©"],
  answer: "5 Î©"
},

{
  question: "The diagram shows resistors in parallel. If Râ‚ = 6 Î© and Râ‚‚ = 3 Î©, find equivalent resistance.",
  image: "/images/physics33.png",
  options: ["2 Î©", "9 Î©", "3 Î©", "1 Î©"],
  answer: "2 Î©"
},

{
  question: "The diagram shows a circuit with current flowing. What is the unit of current?",
  image: "/images/physics34.png",
  options: ["Ampere", "Volt", "Ohm", "Watt"],
  answer: "Ampere"
},

{
  question: "The diagram shows a bulb connected to a battery. If power is 60 W and voltage is 12 V, find current.",
  image: "/images/physics35.png",
  options: ["5 A", "2 A", "10 A", "12 A"],
  answer: "5 A"
},

{
  question: "The diagram shows a circuit. If voltage is constant, increasing resistance will:",
  image: "/images/physics36.png",
  options: ["Decrease current", "Increase current", "No effect", "Stop current"],
  answer: "Decrease current"
},

{
  question: "The diagram shows electrical energy usage. If power is 100 W used for 2 hours, find energy in joules.",
  image: "/images/physics37.png",
  options: ["720000 J", "200 J", "1000 J", "360000 J"],
  answer: "720000 J"
},

{
  question: "The diagram shows two bulbs in series. If one bulb fails, what happens to the other?",
  image: "/images/physics38.png",
  options: ["Goes off", "Remains on", "Brighter", "Dimmer"],
  answer: "Goes off"
},

{
  question: "The diagram shows two bulbs in parallel. If one bulb fails, what happens to the other?",
  image: "/images/physics39.png",
  options: ["Remains on", "Goes off", "Dimmer", "Brighter"],
  answer: "Remains on"
},

{
  question: "The diagram shows a circuit with a switch. When the switch is open, current is:",
  image: "/images/physics40.png",
  options: ["Zero", "Maximum", "Constant", "Variable"],
  answer: "Zero"
},

{
  question: "The diagram shows a current-carrying conductor in a magnetic field. The force on the conductor is determined using:",
  image: "/images/physics41.png",
  options: ["Flemingâ€™s left-hand rule", "Flemingâ€™s right-hand rule", "Ohmâ€™s law", "Lenzâ€™s law"],
  answer: "Flemingâ€™s left-hand rule"
},

{
  question: "The diagram shows magnetic field lines around a straight conductor. What is the shape of the field?",
  image: "/images/physics42.png",
  options: ["Circular", "Straight", "Radial", "Parallel"],
  answer: "Circular"
},

{
  question: "The diagram shows a solenoid. What is produced when current flows through it?",
  image: "/images/physics43.png",
  options: ["Magnetic field", "Electric field", "Heat", "Light"],
  answer: "Magnetic field"
},

{
  question: "The diagram shows a transformer. If primary voltage is 200 V and secondary is 100 V, what type of transformer is this?",
  image: "/images/physics44.png",
  options: ["Step-down", "Step-up", "Isolation", "Power"],
  answer: "Step-down"
},

{
  question: "The diagram shows electromagnetic induction. When a magnet is moved into a coil, what is induced?",
  image: "/images/physics45.png",
  options: ["Current", "Voltage only", "Heat", "Light"],
  answer: "Current"
},

{
  question: "The diagram shows a conductor moving in a magnetic field. What determines the direction of induced current?",
  image: "/images/physics46.png",
  options: ["Flemingâ€™s right-hand rule", "Left-hand rule", "Newtonâ€™s law", "Ohmâ€™s law"],
  answer: "Flemingâ€™s right-hand rule"
},

{
  question: "The diagram shows field lines between two poles. Where is the field strongest?",
  image: "/images/physics47.png",
  options: ["Where lines are closest", "Where lines are far apart", "At edges", "Nowhere"],
  answer: "Where lines are closest"
},

{
  question: "The diagram shows a wire carrying current placed between magnet poles. What happens to the wire?",
  image: "/images/physics48.png",
  options: ["It experiences a force", "It melts", "It stops current", "Nothing happens"],
  answer: "It experiences a force"
},

{
  question: "The diagram shows an AC generator. What type of current is produced?",
  image: "/images/physics49.png",
  options: ["Alternating current", "Direct current", "No current", "Static current"],
  answer: "Alternating current"
},

{
  question: "The diagram shows energy transformation in a generator. What is the energy conversion?",
  image: "/images/physics50.png",
  options: ["Mechanical to electrical", "Electrical to mechanical", "Heat to light", "Chemical to electrical"],
  answer: "Mechanical to electrical"
}


];

export default physicsQuestions;

